/* istanbul ignore file */
import { TextInput, NumberInput, CurrencyInput, useInputHelper } from 'framework/form';
import { getLastSource } from 'framework/utils';
import { Grid2 as Grid } from '@mui/material';
import { CURRENCIES } from 'framework/ui/field';

const PurchaseInput = ({ className, disabled, currencySource, ...props }: any) => {
  const { getValue: getCurrency } = useInputHelper({ source: currencySource });
  const { getSource, getRawOnChangeCallback, getValue } = useInputHelper(props);
  const rawOnChangeCallback = getRawOnChangeCallback() as any;

  const purchase = getValue() || ({} as any);
  const source = getSource();
  const currency = (getCurrency() as string) || '';

  const onChangeCallback = (value: any) => {
    rawOnChangeCallback({
      [source]: {
        ...purchase,
        ...getLastSource(value),
      },
    });
  };

  const onAmountChangeCallback = (value: any) => {
    rawOnChangeCallback({
      [source]: {
        ...purchase,
        cost: {
          amount: Object.values(value)[0],
        },
      },
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 3 }} sx={{ flexShrink: 1 }}>
        <TextInput
          source={`${source}.name`}
          label="Name"
          value={purchase.name}
          onChangeCallback={onChangeCallback}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }} sx={{ flexShrink: 1 }}>
        <CurrencyInput
          source={`${source}.cost.amount`}
          label="Unit price"
          onChangeCallback={onAmountChangeCallback}
          disabled={disabled}
          suffix={CURRENCIES[currency]}
          maxDecimal={2}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }} sx={{ flexShrink: 1 }}>
        <NumberInput
          source={`${source}.quantity`}
          value={purchase.quantity}
          label="Quantity"
          onChangeCallback={onChangeCallback}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }} sx={{ flexShrink: 1 }}>
        <CurrencyInput
          source={`${source}.total`}
          value={(purchase.quantity || 1) * (purchase.cost?.amount || 0)}
          label="Total price"
          disabled
          suffix={CURRENCIES[currency]}
          maxDecimal={2}
          isControlledValue
        />
      </Grid>
    </Grid>
  );
};

export default PurchaseInput;
